import axios, { AxiosResponse } from 'axios';

// local test baseURL
// axios.defaults.baseURL = '/';
axios.defaults.baseURL =
  'https://cartorioonlinebrasil.com.br/wp-content/themes/Divi-tema-filho/calc/';

const responseBody = (response: AxiosResponse) => response.data;

const requests = {
  get: (url: string) => axios.get(url).then(responseBody),
  post: (url: string, body: {}) => axios.post(url, body).then(responseBody),
  put: (url: string, body: {}) => axios.put(url, body).then(responseBody),
  delete: (url: string) => axios.delete(url).then(responseBody),
};

const Prices = {
  list: (): Promise<any> => requests.get('prices.json'),
};

export default {
  Prices,
};
